<template>
    <div class="day-timeline-body">
        <div v-if="timelineData && timelineData.length" class="w-100 overflow-x-auto h-100">
            <day-line-timeline v-for="(header, index) in ['Line 1', 'Line 2']" :key="header" :line-data="timelineData[index]" :header="header" class="timeline-line"></day-line-timeline>
        </div>
    </div>
</template>
<style scoped>
    .day-timeline-body {
        width: 100%;
        height: 100%;
        padding: 5px;
        position: relative;
    }
    .timeline-line {
        border-bottom:1px solid grey;
    }
</style>
<script>
    import { mapActions } from "vuex";
    export default {
        name: "DayTimeline",
        props: {
            openView: Boolean,
            timelineData: {
                type: Array,
                default: () => []
            }
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
        }
    };
</script>
